export const PARTICIPANT_ROUTE_DATA = {
    GETTING_STARTED: {
        PATH: '',
        PAGE: 'RegistrationIdentity',
    },
    CREATE_ACCOUNT: {
        PATH: 'create-account',
        PAGE: 'RegistrationCredentials',
    },
    ACCOUNT_DETAILS: {
        PATH: 'account-details',
        PAGE: 'RegistrationContactInfo',
    },
    IDENTITY_BASE: {
        PATH: 'identity',
    },
    ADD_ROLES: {
        PATH: 'add-roles',
    },
    RISK_BASED: {
        PATH: 'risk-based',
    },
    PROCESS_EXISTING: {
        PATH: 'process-existing',
        PAGE: 'RegistrationProcessExisting',
    },
    COMPLETE: {
        PATH: 'complete',
        PAGE: 'RegistrationComplete',
    },
    ID_PROOFING: {
        BASE: {
            PATH: 'id-verification',
        },
        BYPASS_CODE: {
            PATH: 'registration-code',
            PAGE: 'RegistrationIdProofingRegistrationCode',
        },
        METHODS: {
            PATH: 'method',
            PAGE: 'RegistrationIdProofingMethods',
        },
        PHOTO_ID: {
            PATH: 'photo-id',
            PAGE: 'RegistrationIdProofingPhotoId',
        },
        PHONE_VERIFICATION: {
            PATH: 'phone-verification',
            PAGE: 'RegistrationIdProofingPhoneVerification',
        },
        UNSUCCESSFUL: {
            PATH: 'unsuccessful',
            PAGE: 'RegistrationIdProofingUnsuccessful',
        },
    },
};
